import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Grid, Link, Typography, useTheme} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { IRaDetailView } from "../../models/models";
import {FormDateTimePicker, FormTextField} from "../../common/form-fields-wrappers";
import {useRecoilValue} from "recoil";
import {raDetailState} from "../state";

const SubstitutionInfo = () => {
    const {t} = useTranslation(['network', 'translation']);
    const theme = useTheme();

    const raDetailForm = useFormContext<IRaDetailView>();
    const raDetail = useRecoilValue(raDetailState);

    return (
        <Accordion>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant={"bodyLarge"}>
                    {t("raDetail.substitutionInfo.accordion.title")}
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                {
                    raDetail.substitutionInfo.childrenRaList
                        .map((elem: any, index: number) =>
                            <Box key={"substitution_" + index}>
                                <Typography variant={"bodyLarge"}>
                                    {t("raDetail.substitutionInfo.accordion.subtitle")} {`N${index + 1}`}
                                    <Link href={(window as any).appConfig.HOMEPAGE_ORIGIN + '/network/ra-detail/' + elem.idRentalAgreement} color={"secondary"} variant={"h6"} target={"_blank"} sx={{ml: theme.spacing(2)}}>
                                        Link
                                    </Link>
                                </Typography>
                                <Grid container columnSpacing={2} key={"additionalDriverInfo-" + index} sx={{mb: theme.spacing(2)}}>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`substitutionInfo.${index}.idRentalAgreement`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.substitutionInfo.form.label.idRA")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormTextField<IRaDetailView>
                                            name={`substitutionInfo.${index}.raState`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.substitutionInfo.form.label.raState")}
                                            fullWidth
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormDateTimePicker<IRaDetailView>
                                            name={`substitutionInfo.${index}.pickupDate`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.substitutionInfo.form.label.pickupDate")}
                                            disabled
                                        />
                                    </Grid>
                                    <Grid item xs={6} md={3} sx={{display: "flex", alignItems: "center"}}>
                                        <FormDateTimePicker<IRaDetailView>
                                            name={`substitutionInfo.${index}.dropoffDate`}
                                            control={raDetailForm.control}
                                            label={t("raDetail.substitutionInfo.form.label.dropoffDate")}
                                            disabled
                                        />
                                    </Grid>
                                </Grid>
                            </Box>
                        )
                }
            </AccordionDetails>
        </Accordion>
    );
}

export default SubstitutionInfo;